import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';
import MyCollectionProtocol from '../controller/MyCollectionProtocol.js';
import ErrorModal from './_ErrorModal.jsx';

import PartOutModal from './_PartOutModal.jsx';
import SaveAddItemResModal from './_SaveAddItemResModal.jsx';
import { CommonUtils, ItemDetailInfo, ItemInvUtil } from '../controller/MyCollectionUtils.js';

export default class AddItem extends BLComponent {
	constructor(props, context) {
		super(props, context);	// This should come first. 
		const itemTypeString = {
			S: ["S", "set", "sets", "Set", "Sets"],
			P: ["P", "part", "parts", "Part", "Parts"],
			B: ["B", "book", "books", "Book", "Books"],
			C: ["C", "catalog", "catalogs", "Catalog", "Catalogs"],
			G: ["G", "gear", "gear", "Gear", "Gear"],
			M: ["M", "minifigure", "minifigures", "Minifigure", "Minifigures"]

		}
		this.state = {
			itemAdded: this.props.data.itemAdded
			, selectedItemType: this.props.data.itemType
			, itemType: itemTypeString[this.props.data.itemType]
			, setPartOutIdx: -1
			, resModalShow: false
			, addRes: {}
			, showColorSelect: -1
			, errorType: ""
			, retrySave: false
			, statusPartOut: 1 // 1. part out option, 2. saving, 3. error with retry, 4. error
			, isPartOutResModal: false
			, itemInv:false
		};
	}

	componentWillUnmount() {
		this.props.func.saveItemAdded(this.state.itemAdded, this.state.selectedItemType);
	}

	componentDidMount() {
		const itemAdded = this.state.itemAdded;
		if ((itemAdded == null) || (itemAdded.length == 0)) {
			this.insItem(0);
		}
	}

	render() {
		const listFull = (this.state.itemType[0] == "G")?this.getItemListGear():this.getItemList();
		const listCompact = this.getCompactItemList();
		
		return (
			<section className="l-margin-top">
				<div className="personal-inventory__section-add-sets l-margin-bottom">
					{listFull}
					{listCompact}
				</div>
				<div className="l-full-width l-flex l-split">
					<div>
						&nbsp;
					</div>
					<div className="l-full-width l-flex l-column l-end">
						<button className="btn--cta personal-inventory__btn-add l-cursor-pointer" disabled={(this.isReadyToSave()) ? false : true} onClick={() => this.saveMyItems()} id="MPI-submit-btn">Add to My {this.state.itemType[4]}</button>
					</div>
				</div>
				{(this.state.setPartOutIdx >= 0) && <div>{this.renderPartOutModal()}</div>}
				{(this.state.resModalShow) && <div>{this.renderSaveResultModal()}</div>}
				{(this.state.errorType != "") && this.renderSaveErrorModal()}
			</section>
		)
	}

	renderColorSelector(item, idx) {
		return (
			<div className="personal-inventory__part-color-selector l-full-width">
				<div id="MPI-PCC-dropdown" className="l-flex l-split l-full-height  l-center l-pad-y--xs" onClick={() => this.toggleColorSelect(idx)}>
					<div className="personal-inventory__part-color-selector-header">
						{(item.idColor == -1) &&
							<React.Fragment>
								<i className="pdp-color__selector-header-icon"></i> <span>Choose color</span>
							</React.Fragment>
						}
						{(item.idColor >= 0) &&
							<React.Fragment>
								<ul>
									<li className="personal-inventory__color-select-dropdown-list-row l-flex l-center">
										<div className={"personal-inventory__color-select-dropdown-list-rgb-box " + (((item.strColorName == "White") || (item.idColor == 0)) ? "l-border" : "")} style={{ backgroundColor: "#" + ((item.strColorHex == "") ? "FFFFFF" : item.strColorHex) }}></div>
										<div className="personal-inventory__one-line-cutter">{item.strColorName}</div>
									</li>
								</ul>
							</React.Fragment>
						}

					</div>

					<div className="personal-inventory__part-color-selector-header">
						<i className={"fas fa-chevron-" + ((idx == this.state.showColorSelect) ? "up" : "down")} />
					</div>
				</div>
				{((this.state.showColorSelect == idx) && (item.listColor != null)) && this.renderColorList(item.listColor.colorList, idx)}

			</div>
		)
	}

	renderColorList(listColor, itemIdx) {
		const colorList = listColor.map((color, colorIdx) => {	
			const rgb = CommonUtils.getColorHexCode(color);
			return (
				<li key={"colorIdx" + colorIdx} className="personal-inventory__color-select-dropdown-list-row l-margin-bottom--sm">
					<div className="l-flex l-cursor-pointer" onClick={() => this.updateItemColor(itemIdx, color.ci)}>
						<div className={"personal-inventory__color-select-dropdown-list-rgb-box " + (((color.idColor == 0) || (color.idColor == 1)) ? "l-border" : "")} style={{ backgroundColor: rgb }}></div>
						<div>{color.ci.strColorName}</div>
					</div>
				</li>);
		}
		);

		return (
			<div className={"personal-inventory__color-select-dropdown"} >
				<div className="personal-inventory__color-select-dropdown-list l-flex">
					<ul className="l-full-width">
						{colorList}
					</ul>
				</div>
			</div>
		)
	}

	renderSaveErrorModal() {
		const errorType = this.state.errorType;
		return (
			<ErrorModal data={{ errorType: errorType, itemType: "S" }} func={{ cancelSaveItems: () => this.cancelSaveItems(), retrySaveItems: () => this.retrySaveItems() }} />
		)
	}

	renderAutofillList(idx) {
		const searchResults = this.state.itemAdded[idx].searchResults;

		if (searchResults.length == 0) {
			return (
				<div id={"autofill-result-" + idx} className={"personal-inventory__autofill-list-box" + " autofill-result-" + idx} >
					<div className="personal-inventory__autofill-list l-flex">
						<div className="l-flex l-center-v">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm6 3H6v5h5V6zm0 7H6v1h5v-1z" fill="#0A1E32" />
							</svg>
						</div>
						<div className="personal-inventory__text-light-gray">Add any {this.state.itemType[1]} from the BrickLink Catalog to your My {this.state.itemType[4]} collection</div>
					</div>
				</div>
			)
		}
		else {
			const searchList = searchResults.map((result, searchIdx) => {
				const imgUrl = result.imgUrl;
				const itemNo = result.itemNumber;
				const itemName = result.itemName;
				return (
					<li key={"scRes" + searchIdx} className="personal-inventory__section-autofill-row l-cursor-pointer" onMouseDown={(e) => this.addItem(idx, searchIdx)}>
						<div className="l-flex">
							<img className={"personal-inventory__section-autofill-thumb itemSearchImg-" + (searchIdx)} src={imgUrl} onError={() => this.imgErrorProc(searchIdx)} />
							<div id={"noItemSearchImg-" + searchIdx} className="l-center-v l-full-height text--center l-hide">
								<div className="l-margin-y--auto l-flex l-center-v l-center l-full-height">
									<svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd" d="m30.495 9.505-.623-.624A3 3 0 0 0 27.753 8H15A3.01 3.01 0 0 0 12 11.006V28l3-3V11.007h9.997v3.997l3-3v-.754l.377.377 2.121-2.121zM17.313 34l4.842-4.842.843.843 5.467-5.468a.75.75 0 0 1 1.063 0l1.468 1.469V34H17.313zm-2.314 2.313v.687h17.997V19.004h-.686l3.572-3.572c.074.264.113.539.113.816v20.753a3 3 0 0 1-3 2.999H15a2.996 2.996 0 0 1-2.436-1.25L15 36.314zm5.869-17.182a3 3 0 0 0-3.74 3.74l3.74-3.74zM37.414 8.414a2 2 0 0 1 0 2.829L10.243 38.414a2 2 0 1 1-2.829-2.828L34.586 8.414a2 2 0 0 1 2.828 0z" fill="#0A1E32" />
									</svg>
								</div>
							</div>

							<div className="l-margin-left">
								<div className="personal-inventory__section-autofill-itemName">
									{itemName}
								</div>
								<div className="personal-inventory__section-autofill-itemNo">
									Item No : {itemNo}
								</div>
							</div>
						</div>
					</li>
				)
			})

			return (
				<div id={"autofill-result-" + idx} className={"personal-inventory__autofill-list-box" + " autofill-result-" + idx}>
					<div className="personal-inventory__autofill-list l-flex">
						<ul className="personal-inventory__section-autofill l-full-width">
							{searchList}
						</ul>
					</div>
				</div>
			)
		}

	}

	renderSaveResultModal() {
		return (
			<SaveAddItemResModal data={{ itemType: this.state.itemType[0], addRes: this.state.addRes }} func={{ closeAddItemResModal: () => this.closeAddItemResModal() }} />
		)
	}

	renderPartOutModal() {
		const idx = parseInt(this.state.setPartOutIdx);
		const itemName = this.state.itemAdded[idx].itemNo + ": " + this.state.itemAdded[idx].itemName;
		const partoutOptions = this.state.itemAdded[idx].partout;
		const statusPartOut = this.state.statusPartOut;
		const item = this.state.itemAdded[idx];
		const { itemType } = this.props.data;
		const itemInvData = ItemInvUtil.getItemInvData(item.itemId);

		return (
			<PartOutModal
				data={
					{
						title: "Part out options"
						, idx: idx
						, itemName: itemName
						, itemType: itemType
						, partoutOptions: partoutOptions
						, statusPartOut: statusPartOut
						, item:item
						, itemInvData: itemInvData
					}
				}
				func={
					{

						savePartOutOptions: (idx, partoutOptions) => this.savePartOutOptions(idx, partoutOptions)
						, partoutSet:  (idx, partoutOptions) => this.partoutSet(idx, partoutOptions)
						, closePartOutModal: (idx, status) => this.closePartOutModal(idx, status)
						, reloadTriggerOn: () => this.props.func.reloadTriggerOn()
					}
				}
			/>
		)
	}

	addItem(idx, searchIdx) {
		const { itemType } = this.props.data;
		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];
		let colorError = false;

		const selectedRes = item.searchResults[searchIdx];

		if ( !"PC".includes(itemType) ) {

			if (ItemInvUtil.getItemInvData(selectedRes.itemId) == null) {
				MyCollectionProtocol.reqItemInvInfo(selectedRes.itemId)
				.then(
					(data) => {
						ItemInvUtil.insItemInv(selectedRes.itemId, data);					
						this.setState({itemInv:true});
					}

				).catch(
					(err) => {
						console.log(err);
					}

				)
			}
		}

		if ((itemType == "P") || (itemType == "M") || (itemType == "G")) {
			// GET COLOR INFO
			MyCollectionProtocol.reqListPartColor(selectedRes.itemId, this.state.itemType[0]
			).then(
				(data) => {
					for(var i = 0; i < data.colorList.length; i++) {
						data.colorList[i].ci.strColorName = blapp.util.decodeHtml(data.colorList[i].ci.strColorName);
					}

					item.idColor = -1;
					item.listColor = data;
					item.filled = true;
					item.itemId = selectedRes.itemId;
					item.itemName = selectedRes.itemName;
					item.itemNo = selectedRes.itemNumber;
					item.qty = 1;
					item.condition = 1;
					item.partout = { incRegularParts: false, incExtraParts: false, breakMinifig: false };
					item.itemNote = "";

					if ((data.colorList.length == 0) && (itemType == "P")) {
						// SET DEFAULT COLOR FOR PARTS
						let ci = blapp.color.get(selectedRes.defaultColor);
						data.colorList[0] = { ci: ci };
					}


					if (data.colorList.length == 1) {
						item.idColor = data.colorList[0].ci.idColor;
						item.strColorName = data.colorList[0].ci.strColorName;
						item.strColorHex = data.colorList[0].ci.strColorHex;
					}

					itemAdded[idx] = item;
					this.setState({ itemAdded: itemAdded });
				}
			).catch(
				(err) => {
					console.log(err);
					colorError = true;
				}

			)
		}
		else {
			item.filled = true;
			item.itemId = selectedRes.itemId;
			item.itemName = selectedRes.itemName;
			item.itemNo = selectedRes.itemNumber;
			item.itemNote = "";
			item.qty = 1;
			item.condition = 1;
			item.partout = { incRegularParts: false, incExtraParts: false, breakMinifig: false };

			itemAdded[idx] = item;
			this.setState({ itemAdded: itemAdded });
		}
	}

	updateAddedItemNote(idx, e) {
		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];
		const note = e.target.value;

		item.itemNote = note;

		itemAdded[idx] = item;
		this.setState({itemAdded: itemAdded});
	}

	updateAddedItemQty(idx, e) {
		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];

		let qty = parseInt(e.target.value);
		if (!(qty >= 0)) {
			qty = "";
		}
		item.qty = qty;

		itemAdded[idx] = item;
		this.setState({ itemAdded: itemAdded });
	}

	updateItemName(e, idx) {
		var itemAdded = this.state.itemAdded;
		let keyword = itemAdded[idx]["keyword"];
		let newKeyword = "";

		itemAdded[idx]["keyword"] = e.target.value;
		itemAdded[idx]["filled"] = false;
		this.setState({ itemAdded: itemAdded, searchResults: [] }, this.getAutofillData(idx, itemAdded[idx]["keyword"]));
	}

	partoutSet(idx, partoutOptions) { // for Set, Gear, Book, Catalog
		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];
		
		item.partout = partoutOptions;

		//this.saveMyItems( [item] );

		itemAdded.splice(idx,1);
		this.setState({ itemAdded: itemAdded });
	}

	savePartOutOptions(idx, partoutOptions) { // for Set, Gear, Book, Catalog
		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];

		item.partout = partoutOptions;

		itemAdded[idx] = item;
		this.setState({ itemAdded: itemAdded }, this.closePartOutModal());
	}
	/** ADD ITEM END**/


	/** Auto Fill **/
	showAutofillResult(idx, showing) { // ok
		const searchResults = this.state.itemAdded[idx].searchResults;


		if (showing) {
			$(".autofill-result-" + idx).show();
			$(".magnifire-" + idx).css("border", "1px solid #0788ca");
			$(".magnifire-" + idx).css("borderLeft", "0px");
		}
		else {
			$(".autofill-result-" + idx).hide();
			$(".magnifire-" + idx).css("border", "1px solid #d8dbde");
			$(".magnifire-" + idx).css("borderLeft", "0px");
		}
	}

	getAutofillData(idx, keyword) { // part has cnt res
		MyCollectionProtocol.getSearchQuickWithItemType(
			keyword
			, this.state.itemType[0]
		).then(
			(data) => {
				if (data != null) {

					let searchResults = [];
					const arrItems = data.arrItems;

					for (const item of arrItems) {
						searchResults[searchResults.length] = this.getDataFromBLMCatalogItemWithColor(item, "T2");
					}
					var itemAdded = this.state.itemAdded;
					itemAdded[idx].searchResults = searchResults;
					this.setState({ itemAdded: itemAdded });
				}
			}
		).catch(
			(err) => {
				console.log(err);
			}

		)
	}

	getCntFilledItem() { // ok
		const itemAdded = this.state.itemAdded;
		var cntFilledItem = 0;

		for (var i = 0; i < itemAdded.length; i++) {
			if (itemAdded[i].filled == true) cntFilledItem++;
		}
		return cntFilledItem;
	}

	isReadyToSave() {
		const { itemType } = this.props.data;
		const itemAdded = this.state.itemAdded;
		var cntNotFilled = 0;
		var i = 0;

		for (i = 0; i < itemAdded.length; i++) {
			if (itemAdded[i].filled) {
				if (itemAdded[i].qty <= 0) {
					return false;
				}

				if (itemAdded[i].qty.toString().length > 6) {
					return false;
				}

				if (itemType == "P") {
					if (itemAdded[i].idColor < 0) {
						return false;
					}
				}

				if ((itemType == "M") || (itemType == "G")) {
					if (itemAdded[i].listColor.colorList.length > 0) {
						if (itemAdded[i].idColor < 0) {
							return false;
						}
					}
				}
			}
			if (!itemAdded[i].filled) cntNotFilled++;
		}
		if (cntNotFilled == i) return false;

		return true;
	}

	openPartOutModal(idx) {
		this.setState({ setPartOutIdx: idx });
	}

	getSearchFieldPlaceHolder() {
		if (this.state.selectedItemType == "P") {
			return ("Search for " + this.state.itemType[2] + " to add by name, item number, or PCC");
		}
		else {
			return ("Search for " + this.state.itemType[2] + " to add by name or item number")
		}

	}

	getFullSizeListClass() {
		const selectedItemType = this.state.selectedItemType;
		switch(selectedItemType) {
			case "P" : return "personal-inventory__add-item-with-color-full-size";
			default  : return "personal-inventory__add-item-without-color-full-size";
		}
		
		
	}

	hasItemInv(idx) {
		const invData = ItemInvUtil.getItemInvData( this.state.itemAdded[idx].itemId );
		if (invData == null) return false;
		
		if ( (invData.nRegInvCnt > 0) || (invData.nExtraInvCnt > 0) || (invData.nMinifigureCnt > 0) ) return true;
		return false;
		
	}

	getItemListGear() {
		const itemAdded = this.state.itemAdded;
		const cntAddedItem = itemAdded.length;
		const cntFilledItem = this.getCntFilledItem();
		const isFirstItemFilled = (typeof itemAdded[0] == "undefined") ? false : itemAdded[0].filled;
		const isHeaderAll = (cntFilledItem == cntAddedItem) ? true : (isFirstItemFilled) ? true : false;
		const hasFirstItemColor = (typeof itemAdded[0] == "undefined") ? false : (itemAdded[0].filled) ? (typeof itemAdded[0].listColor == "undefined") ? false : (itemAdded[0].listColor.colorList.length > 0) ? true : false : false;
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;

		const listFull = itemAdded.map((item, idx) => {
			const itemFilled = item.filled;
			const itemName = item.itemName;
			const itemNote = item.itemNote;
			const keyword = item.keyword;
			const partout = item.partout;
			const searchFieldPlaceHolder = this.getSearchFieldPlaceHolder();

			const partoutOn = (typeof partout != "undefined") && (partout.breakMinifig || partout.incExtraParts || partout.incRegularParts) ? true : false;
			const { bHasColor } = ItemDetailInfo.getInfo(item);
			const bHasItemInv = this.hasItemInv(idx);
			
			return (
				<div className="personal-inventory__add-set" key={"listFull" + idx}>
					<div className={ this.getFullSizeListClass() }>
						{(idx == 0) &&
							<SearchFieldHeader 
								data={
									{ 	myCollectionConfig:this.props.data.myCollectionConfig, 
										itemType: this.state.selectedItemType, 
										itemTypeFullStr: this.state.itemType[1], 
										isHeaderAll: isHeaderAll, 
										hasFirstItemColor: hasFirstItemColor, 
										itemNote: itemNote }
								} 
							/>
						}

						<AddedItemControlBtn data={{ cntAddedItem: cntAddedItem, idx: idx }} func={{ insItem: (idx) => this.insItem(idx), removeAddedItem: (idx) => this.removeAddedItem(idx) }} />

						<div className={((!itemFilled) ? "personal-inventory__input-search--full-width " : "") + (((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__min-width-zero" + " personal-inventory__cell--item-name"}>
							
							<div className={"l-full-width l-flex"}>
								{!itemFilled &&
									<React.Fragment>
										<input
											id="MPI-search-textField"
											className={"text-input input-button-set__input l-full-width autofill-search-" + idx}
											type="text"
											placeholder={searchFieldPlaceHolder}
											onFocus={() => this.showAutofillResult(idx, true)}
											onChange={(e) => this.updateItemName(e, idx)}
											onBlur={() => this.showAutofillResult(idx, false)}
											value={keyword}
										/>
										<button className={"personal-inventory__input-search-magnifier-button magnifire-" + idx} ><i className="far fa-search" /></button>

									</React.Fragment>
								}
								{itemFilled &&
									<div className={"l-flex l-split personal-inventory__add-set-itemname" + ((!bHasColor)?" l-full-width":"") + ((this.state.selectedItemType == "G" && bHasColor) ? "  personal-inventory__add-item_name-60 l-margin-right " : "")}>
										<div className="overflow-ellipsis l-pad-right"><strong>{item.itemNo} :</strong> {item.itemName}</div>
										<div className="personal-inventory__icon-x-circle" onClick={() => this.clearItem(idx)} ><i className="far fa-circle-xmark"></i></div>
									</div>
								}
								{(bHasColor) && this.renderColorSelector(item, idx)}

							</div>
							{!itemFilled && this.renderAutofillList(idx)}
						</div>
						{(itemFilled) &&
							<React.Fragment>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-condition"}>
									<ItemConditionDropDown data={{ itemType: this.state.selectedItemType, idx: idx, conditionValue: item.condition, strClass: "l-full-width l-full-height select select--tight" }} func={{ updateCondition: (idx, value) => this.updateCondition(idx, value) }} />
								</div>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-qty"}>
									<input
										className={"text-input " + (this.isValidQty(item.qty) ? "" : "personal-inventory__item-add-qty-err")}
										type="number"
										value={item.qty} id="MPI-qty-textfield"
										onChange={(e) => { this.updateAddedItemQty(idx, e) }} />
								</div>
								{ ( (this.state.selectedItemType !== "C") && (bHasItemInv) )&&
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--partout-button"}>
									<button className={"btn personal-inventory__section-add-sets-btn l-full-width l-full-height personal-inventory__part-out-" + ((partoutOn) ? "on" : "off")} onClick={() => this.openPartOutModal(idx)}>
										<PartOutButton data={{ itemType: this.state.selectedItemType, partoutOn: partoutOn, isCompact: false }} />
									</button>
								</div>
								}
								<div className={"personal-inventory__cell--notes-input" + ( ((cntAddedItem - 1)>idx)?" l-margin-bottom":"" ) + " personal-inventory__cell--notes-input" + ( (!bHasItemInv)? "-no-inv":"") }>
									<div><input type="text" className="text-input l-full-width" placeholder='Type your notes here' maxLength={maxNoteLen} onChange={(e) => this.updateAddedItemNote(idx, e)} value={itemNote}/></div>
								</div>
							</React.Fragment>
						}
						

					</div>
				</div>
			);
		});
		return listFull;

	}

	getItemList() {
		const itemAdded = this.state.itemAdded;
		const cntAddedItem = itemAdded.length;
		const cntFilledItem = this.getCntFilledItem();
		const isFirstItemFilled = (typeof itemAdded[0] == "undefined") ? false : itemAdded[0].filled;
		const isHeaderAll = (cntFilledItem == cntAddedItem) ? true : (isFirstItemFilled) ? true : false;
		const hasFirstItemColor = (typeof itemAdded[0] == "undefined") ? false : (itemAdded[0].filled) ? (typeof itemAdded[0].listColor == "undefined") ? false : (itemAdded[0].listColor.colorList.length > 0) ? true : false : false;
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;

		const listFull = itemAdded.map((item, idx) => {
			const itemFilled = item.filled;
			const itemName = item.itemName;
			const itemNote = item.itemNote;
			const keyword = item.keyword;
			const partout = item.partout;
			const searchFieldPlaceHolder = this.getSearchFieldPlaceHolder();

			const partoutOn = (typeof partout != "undefined") && (partout.breakMinifig || partout.incExtraParts || partout.incRegularParts) ? true : false;
			const { bHasColor } = ItemDetailInfo.getInfo(item);
			const bHasItemInv = this.hasItemInv(idx);
			
			return (
				<div className="personal-inventory__add-set" key={"listFull" + idx}>
					<div className={ this.getFullSizeListClass() }>
						{(idx == 0) &&
							<SearchFieldHeader 
								data={
									{ 	myCollectionConfig:this.props.data.myCollectionConfig, 
										itemType: this.state.selectedItemType, 
										itemTypeFullStr: this.state.itemType[1], 
										isHeaderAll: isHeaderAll, 
										hasFirstItemColor: hasFirstItemColor, 
										itemNote: itemNote }
								} 
							/>
						}

						<AddedItemControlBtn data={{ cntAddedItem: cntAddedItem, idx: idx }} func={{ insItem: (idx) => this.insItem(idx), removeAddedItem: (idx) => this.removeAddedItem(idx) }} />

						<div className={((!itemFilled) ? "personal-inventory__input-search--full-width " : "") + (((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__min-width-zero" + " personal-inventory__cell--item-name"}>
							<div className="l-flex l-full-width">
								{!itemFilled &&
									<React.Fragment>
										<input
											id="MPI-search-textField"
											className={"text-input input-button-set__input l-full-width autofill-search-" + idx}
											type="text"
											placeholder={searchFieldPlaceHolder}
											onFocus={() => this.showAutofillResult(idx, true)}
											onChange={(e) => this.updateItemName(e, idx)}
											onBlur={() => this.showAutofillResult(idx, false)}
											value={keyword}
										/>
										<button className={"personal-inventory__input-search-magnifier-button magnifire-" + idx} ><i className="far fa-search" /></button>

									</React.Fragment>
								}
								{itemFilled &&
									<div className={"l-flex l-split l-full-width personal-inventory__add-set-itemname" + ((this.state.selectedItemType == "G" && bHasColor) ? "  personal-inventory__add-item_name-60 l-margin-right " : "")}>
										<div className="overflow-ellipsis l-pad-right"><strong>{item.itemNo} :</strong> {item.itemName}</div>
										<div className="personal-inventory__icon-x-circle" onClick={() => this.clearItem(idx)} ><i className="far fa-circle-xmark"></i></div>
									</div>
								}
								{(this.state.selectedItemType == "G" && bHasColor) && this.renderColorSelector(item, idx)}

							</div>
							{!itemFilled && this.renderAutofillList(idx)}
						</div>
						{(itemFilled && "SGBCM".includes(this.state.selectedItemType)) &&
							<React.Fragment>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-condition"}>
									<ItemConditionDropDown data={{ itemType: this.state.selectedItemType, idx: idx, conditionValue: item.condition, strClass: "l-full-width l-full-height select select--tight" }} func={{ updateCondition: (idx, value) => this.updateCondition(idx, value) }} />
								</div>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-qty"}>
									<input
										className={"text-input " + (this.isValidQty(item.qty) ? "" : "personal-inventory__item-add-qty-err")}
										type="number"
										value={item.qty} id="MPI-qty-textfield"
										onChange={(e) => { this.updateAddedItemQty(idx, e) }} />
								</div>
								{ ( (this.state.selectedItemType !== "C") && (bHasItemInv) )&&
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--partout-button"}>
									<button className={"btn personal-inventory__section-add-sets-btn l-full-width l-full-height personal-inventory__part-out-" + ((partoutOn) ? "on" : "off")} onClick={() => this.openPartOutModal(idx)}>
										<PartOutButton data={{ itemType: this.state.selectedItemType, partoutOn: partoutOn, isCompact: false }} />
									</button>
								</div>
								}
								<div className={"personal-inventory__cell--notes-input" + ( ((cntAddedItem - 1)>idx)?" l-margin-bottom":"" ) + " personal-inventory__cell--notes-input" + ( (!bHasItemInv)? "-no-inv":"") }>
									<div><input type="text" className="text-input l-full-width" placeholder='Type your notes here' maxLength={maxNoteLen} onChange={(e) => this.updateAddedItemNote(idx, e)} value={itemNote}/></div>
								</div>
							</React.Fragment>
						}
						{(itemFilled && (this.state.selectedItemType == "P")) &&
							<React.Fragment>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-color"}>
									<div className="personal-inventory__part-color-selector">
										<div id="MPI-PCC-dropdown" className="l-flex l-split l-full-height" onClick={() => this.toggleColorSelect(idx)}>
											<div className="personal-inventory__part-color-selector-header">
												{(item.idColor == -1) &&
													<React.Fragment>
														<i className="pdp-color__selector-header-icon"></i> <span>Choose color</span>
													</React.Fragment>
												}
												{(item.idColor >= 0) &&
													<React.Fragment>
														<ul>
															<li className="personal-inventory__color-select-dropdown-list-row l-flex l-center">
																<div className={"personal-inventory__color-select-dropdown-list-rgb-box " + ((item.strColorName == "White") ? "l-border" : "")} style={{ backgroundColor: "#" + item.strColorHex }}></div>
																<div className="personal-inventory__one-line-cutter">{item.strColorName}</div>
															</li>
														</ul>
													</React.Fragment>
												}

											</div>

											<div className="personal-inventory__part-color-selector-header">
												<i className={"fas fa-chevron-" + ((idx == this.state.showColorSelect) ? "up" : "down")} />
											</div>
										</div>
										{((this.state.showColorSelect == idx) && (item.listColor != null)) && this.renderColorList(item.listColor.colorList, idx)}

									</div>
								</div>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-condition"}>
									<ItemConditionDropDown data={{ itemType: this.state.selectedItemType, idx: idx, conditionValue: item.condition, strClass: "l-full-width select" }} func={{ updateCondition: (idx, value) => this.updateCondition(idx, value) }} />
								</div>
								<div className={(((cntAddedItem - 1) > idx) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-qty"}>
									<input
										className={"text-input l-full-width " + (this.isValidQty(item.qty) ? "" : "personal-inventory__item-add-qty-err")}
										type="number"
										value={item.qty} id="MPI-qty-textfield"
										onChange={(e) => { this.updateAddedItemQty(idx, e) }} />
								</div>
								<div className={"personal-inventory__cell--notes-input" + ( ((cntAddedItem - 1)>idx)?" l-margin-bottom":"" ) }>
									<div><input type="text" className="text-input l-full-width" placeholder='Type your notes here' maxLength={maxNoteLen} onChange={(e) => this.updateAddedItemNote(idx, e)} value={itemNote}/></div>
								</div>				
							</React.Fragment>
						}

					</div>
				</div>
			);
		});
		return listFull;
	}

	getCompactItemList() {
		const itemAdded = this.state.itemAdded;
		const cntAddedItem = itemAdded.length;
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;

		const listCompact = itemAdded.map((item, idx) => {
			const itemType = this.state.selectedItemType;
			const itemFilled = item.filled;
			const itemName = item.itemName;
			const itemNote = item.itemNote;
			const keyword = item.keyword;
			const partout = item.partout;
			const searchFieldPlaceHolder = this.getSearchFieldPlaceHolder();
			const partoutOn = (typeof partout != "undefined") && (partout.breakMinifig || partout.incExtraParts || partout.incRegularParts) ? true : false;
			const hasColor = (item.filled) ? (typeof item.listColor == "undefined") ? false : (item.listColor.colorList.length > 0) ? true : false : false;
			const bHasItemInv = this.hasItemInv(idx);;
			
			return (
				<div className="personal-inventory__add-set-small-size" key={"listFull" + idx}>
					<React.Fragment>
						<div className={"personal-inventory__cell--find-header"}>Find a {this.state.itemType[1]}</div>
					</React.Fragment>
					<AddedItemControlBtn data={{ cntAddedItem: cntAddedItem, idx: idx }} func={{ insItem: (idx) => this.insItem(idx), removeAddedItem: (idx) => this.removeAddedItem(idx) }} />
					<div className={"personal-inventory__input-search--full-width " + ((((cntAddedItem - 1) > idx) && !itemFilled) ? " l-margin-bottom" : "") + " personal-inventory__cell--item-name"}>
						<div className="l-flex l-full-width personal-inventory__min-width-zero">
							{!itemFilled &&
								<React.Fragment>
									<input
										id="MPI-search-textField"
										className={"personal-inventory__hide-mobile text-input input-button-set__input l-full-width autofill-search-" + idx}
										type="text"
										placeholder={searchFieldPlaceHolder}
										onFocus={() => this.showAutofillResult(idx, true)}
										onChange={(e) => this.updateItemName(e, idx)}
										onBlur={() => this.showAutofillResult(idx, false)}
										defaultValue={keyword}
									/>
									<input
										id="MPI-search-textField"
										className={"personal-inventory__show-only-mobile text-input input-button-set__input l-full-width autofill-search-" + idx}
										type="text"
										placeholder={"Search for " + this.state.itemType[2] + " to add"}
										onFocus={() => this.showAutofillResult(idx, true)}
										onChange={(e) => this.updateItemName(e, idx)}
										onBlur={() => this.showAutofillResult(idx, false)}
										defaultValue={keyword}
									/>
									<button className={"personal-inventory__input-search-magnifier-button magnifire-" + idx} ><i className="far fa-search" /></button>
								</React.Fragment>
							}
							{itemFilled &&
								<div className="l-flex l-split l-full-width personal-inventory__add-set-itemname">
									<div className="overflow-ellipsis l-pad-right"><strong>{item.itemNo} :</strong> {item.itemName}</div>
									<div className="personal-inventory__icon-x-circle" onClick={() => this.clearItem(idx)} ><i className="fa fa-solid fa-circle-xmark"></i></div>
								</div>
							}
						</div>
						{!itemFilled && this.renderAutofillList(idx)}
					</div>

					{(itemFilled && ("SMGB".includes(itemType))) &&
						<React.Fragment>
							{hasColor && this.state.selectedItemType == "G" &&
								<React.Fragment>
								<div className="personal-inventory__cell--item-color">
									<div className="personal-inventory__input-search--full-width ">
										Gear color
									</div>
									
									<div className="personal-inventory__input-search--full-width ">
										{this.renderColorSelector(item, idx)}
									</div>
								</div>
								</React.Fragment>
							}

							<div className={" personal-inventory__cell--item-condition" + ((bHasItemInv)?"-po":"" ) + " l-margin-top--sm"}>
								<div>Condition</div>
								<ItemConditionDropDown data={{ itemType: this.state.selectedItemType, idx: idx, conditionValue: item.condition, strClass: "l-full-width select" }} func={{ updateCondition: (idx, value) => this.updateCondition(idx, value) }} />
							</div>
							<div className={" personal-inventory__cell--item-qty" + ((bHasItemInv)?"-po":"" ) + " l-margin-top--sm"}>
								<div>Qty</div>
								<input
									className={"text-input " + (this.isValidQty(item.qty) ? "" : "personal-inventory__item-add-qty-err")}
									type="number"
									value={item.qty} id="MPI-qty-textfield"
									onChange={(e) => { this.updateAddedItemQty(idx, e) }} />
							</div>
							{ bHasItemInv &&
							<div className={"l-flex l-column personal-inventory__cell--partout-button  l-margin-top--sm"}>
								<div className="l-flex"><span className="personal-inventory__show-only-mobile">Part Out</span>&nbsp;</div>
								<button className={"btn personal-inventory__section-add-sets-btn l-full-width l-full-height personal-inventory__part-out-" + ((partoutOn) ? "on" : "off")} onClick={() => this.openPartOutModal(idx)}>
									<PartOutButton data={{ itemType: this.state.selectedItemType, partoutOn: partoutOn, isCompact: true }} />
								</button>
							</div>
							}
							<div className={"personal-inventory__cell--notes-input" + ( ((cntAddedItem - 1)>idx)?" l-margin-bottom":"" ) + " personal-inventory__cell--notes-input" }>
								<div className={"l-margin-top--sm"}>Notes ({maxNoteLen} characters max)</div>
								<div><input type="text" className="text-input l-full-width" placeholder='Type your notes here' maxLength={maxNoteLen} onChange={(e) => this.updateAddedItemNote(idx, e)} value={itemNote}/></div>
							</div>
						</React.Fragment>
					}

					{(itemFilled && ("PC".includes(this.state.selectedItemType))) &&
						<React.Fragment>
							{ (itemType == "P")&&
								<div className={"personal-inventory__cell--item-color"}>
									
									<div>
										<div className="personal-inventory__cell--color-header l-margin-top--sm">Part Color</div>

										<div className="personal-inventory__part-color-selector l-pad-y--xs">
											<div id="MPI-PCC-dropdown" className="l-flex l-split l-full-height l-center" onClick={() => this.toggleColorSelect(idx)}>
												<div className="personal-inventory__part-color-selector-header">
													{(item.idColor == -1) &&
														<React.Fragment>
															<i className="pdp-color__selector-header-icon"></i> <span>Choose color</span>
														</React.Fragment>
													}
													{(item.idColor >= 0) &&
														<React.Fragment>
															<ul>
																<li className="personal-inventory__color-select-dropdown-list-row l-flex l-center">
																	<div className={"personal-inventory__color-select-dropdown-list-rgb-box " + ((item.strColorName == "White") ? "l-border" : "")} style={{ backgroundColor: "#" + item.strColorHex }}></div>
																	<div className="personal-inventory__one-line-cutter">{item.strColorName}</div>
																</li>
															</ul>
														</React.Fragment>
													}

												</div>

												<div className="personal-inventory__part-color-selector-header">
													<i className={"fas fa-chevron-" + ((idx == this.state.showColorSelect) ? "up" : "down")} />
												</div>
											</div>
											{((this.state.showColorSelect == idx) && (item.listColor != null)) && this.renderColorList(item.listColor.colorList, idx)}
										</div>
									</div>

								</div>
							}
							
							<div className={" personal-inventory__cell--item-condition"}>
								<div className="l-margin-top--sm">Condition</div>
								<ItemConditionDropDown data={{ itemType: this.state.selectedItemType, idx: idx, conditionValue: item.condition, strClass: "l-full-width select" }} func={{ updateCondition: (idx, value) => this.updateCondition(idx, value) }} />
							</div>
							<div className={"personal-inventory__cell--item-qty"}>
								<div className="l-margin-top--sm">Qty</div>
								<input
									className={"text-input " + (this.isValidQty(item.qty) ? "" : "personal-inventory__item-add-qty-err")}
									type="number"
									value={item.qty} id="MPI-qty-textfield"
									onChange={(e) => { this.updateAddedItemQty(idx, e) }} />
							</div>
								
							<div className={"personal-inventory__cell--notes-input" + ( ((cntAddedItem - 1)>idx)?" l-margin-bottom":"" ) + " personal-inventory__cell--notes-input" }>
								<div className={"l-margin-top--sm"}>Notes ({maxNoteLen} characters max)</div>
								<div><input type="text" className="text-input l-full-width" placeholder='Type your notes here' maxLength={maxNoteLen} onChange={(e) => this.updateAddedItemNote(idx, e)} value={itemNote}/></div>
							</div>

						</React.Fragment>
					}
				</div>
			);
		});

		return listCompact;
	}
	

	imgErrorProc(idx) {

		$(".itemSearchImg-" + idx).hide();
		$("#noItemSearchImg-" + idx).show();
	}

	closePartOutModal(idx, status) {
		if (status == 99) {
			this.removeAddedItem(idx);
		}
		this.setState({ setPartOutIdx: -1 });
	}
	closeAddItemResModal() {
		this.setState({ resModalShow: false }, this.props.func.reloadTriggerOn());
	}

	updateCondition(idx, condition) {
		let itemAdded = this.state.itemAdded;
		itemAdded[idx].condition = condition;
		this.setState({ itemAdded: itemAdded });
	}


	saveMyItems() {
		// Request to Save
		const { itemType } = this.props.data;
		const itemAdded = this.state.itemAdded;
		let arrAddedItem = [];

		for (const item of itemAdded) {
			if (item.filled == true) {
				const partout = (item.partout.incRegularParts || item.partout.incExtraParts)?true:false;
			
				switch (itemType) {
					case "S": case "B": case "C":
						arrAddedItem[arrAddedItem.length] = { itemType: this.state.itemType[0], itemId: item.itemId, itemCondition: parseInt(item.condition), qty: item.qty, partout: item.partout.incRegularParts, includeRegular: item.partout.incRegularParts, includeExtra: item.partout.incExtraParts, breakMinifigure: item.partout.breakMinifig, itemNote: item.itemNote };
						break;
					case "P":
						arrAddedItem[arrAddedItem.length] = { itemType: this.state.itemType[0], itemId: item.itemId, itemCondition: parseInt(item.condition), qty: item.qty, colorId: item.idColor, itemNote: item.itemNote };
						break;
					case "G": case "M":
						if ((item.listColor.colorList.length > 0) && (item.idColor < 0)) {
							continue;
						}
						arrAddedItem[arrAddedItem.length] = { itemType: this.state.itemType[0], itemId: item.itemId, itemCondition: parseInt(item.condition), qty: item.qty, partout: item.partout.incRegularParts, includeRegular: item.partout.incRegularParts, includeExtra: item.partout.incExtraParts, breakMinifigure: item.partout.breakMinifig, itemNote: item.itemNote };
						if (item.idColor >= 0) arrAddedItem[arrAddedItem.length - 1].colorId = item.idColor;
						break;
				}
			}

		}
		
		MyCollectionProtocol.reqAddItems(
			arrAddedItem
		).then(
			(data) => {
				if (data != null) {
					let itemAddedEmpty = [];
					itemAddedEmpty[0] = this.getEmptyItem();
					this.setState({ addRes: data, resModalShow: true, itemAdded: itemAddedEmpty });
				}
			}
		).catch(
			(err) => {
				if (err != "NOT_LOGGED_IN") {
					let errType = "";
					if (this.state.retrySave)
						errType = "failure";
					else
						errType = "generalError";
					this.setState({ errorType: errType, retrySave: false });
				}
			}

		)
	}

	isValidQty(qty) {
		if (qty.toString().length > 6) return false;
		if (qty <= 0) return false;
		return true;
	}

	cancelSaveItems() {
		this.setState({ errorType: "", retrySave: false });
	}

	retrySaveItems() {
		this.setState({ errorType: "", retrySave: true }, this.saveMyItems());
	}

	toggleColorSelect(idx) {
		const bShowingColorSelect = (this.state.showColorSelect >= 0) ? true : false;
		const newShowColorSelect = ((bShowingColorSelect) && (idx != this.state.showColorSelect)) ? idx : (!bShowingColorSelect) ? idx : -1;

		this.setState({ showColorSelect: newShowColorSelect });
	}

	updateItemColor(itemIdx, ci) {
		let itemAdded = this.state.itemAdded;
		itemAdded[itemIdx].idColor = ci.idColor;
		itemAdded[itemIdx].strColorName = ci.strColorName;
		itemAdded[itemIdx].strColorHex = ci.strColorHex;

		this.setState({ itemAdded: itemAdded, showColorSelect: -1 });
	}

	togglePartOutOption(idx) {
		const partOutOn = { breakMinifig: true, incExtraParts: false, incRegularParts: true };
		const partOutOff = { breakMinifig: false, incExtraParts: false, incRegularParts: false };

		let itemAdded = this.state.itemAdded;
		let item = itemAdded[idx];
		const partout = (item.partout.incRegularParts) ? partOutOff : partOutOn;

		item.partout = partout;
		itemAdded[idx] = item;
		this.setState({ itemAdded: itemAdded });
	}

	getDataFromBLMCatalogItemWithColor(item, imgSize) {
		const { itemType } = this.props.data;
		const defaultColor = (itemType == "P") ? item.dmItem.idColorDefault : 0;
		return {
			imgUrl: blapp.url2.getCatalogItemImgUrl(item.dmImg, imgSize)
			, itemId: item.dmItem.idItem
			, itemNumber: item.dmItem.strItemNoFull
			, itemName: item.dmItem.strItemName
			, defaultColor: defaultColor
		}
	}

	getEmptyItem() {
		return { keyword: "", filled: false, searchResults: [] };
	}

	insItem(idx) {
		const { itemType } = this.props.data;
		let items = this.state.itemAdded;

		items.splice(idx + 1, 0, this.getEmptyItem());

		switch (itemType) {
			case "S": case "B": case "C": case "G": case "M":
				this.setState({ itemAdded: items });
				break;
			case "P":
				this.setState({ itemAdded: items, showColorSelect: -1 });
				break;
		}
	}

	clearItem(idx) {
		const { itemType } = this.props.data;
		var items = this.state.itemAdded;
		items[idx] = this.getEmptyItem();
		this.props.func.clearItemAdded(itemType);
		this.setState({ itemAdded: items, showColorSelect: -1 });

	}

	removeAddedItem(idx) {
		var itemAdded = this.state.itemAdded;
		itemAdded.splice(idx, 1);
		if (itemAdded.length == 0) itemAdded[0] = this.getEmptyItem();
		this.setState({ itemAdded: itemAdded, showColorSelect: -1 });

	}


};

export class SearchFieldHeader extends React.Component {
	constructor(props) {
		super(props);
	}


	render() {
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;
		const { itemType, itemTypeFullStr, isHeaderAll, hasFirstItemColor, itemNote } = this.props.data;
		
		if ("SBCM".includes(itemType)) {
			return (
				<React.Fragment>
					<div className="personal-inventory__cell--find-header">Find a {itemTypeFullStr}</div>
					{isHeaderAll &&
						<React.Fragment>
							<div className="personal-inventory__cell--condition-header">Condition</div>
							<div className="personal-inventory__cell--qty-header">Qty</div>
							<div className="personal-inventory__cell--notes-header l-flex">
								<div>Notes</div>
								<div className="l-full-width personal-inventory__text-light-gray l-margin-left--sm">({maxNoteLen} characters max)</div>
							</div>
						</React.Fragment>
					}
				</React.Fragment>
			)
		}

		if (itemType == "G") {
			return (
				<React.Fragment>
					<div className="l-flex personal-inventory__cell--find-header">
						<div className={(hasFirstItemColor) ? " personal-inventory__add-item_name-60 " : ""}>Find a {itemTypeFullStr}</div>
						
					</div>
					{isHeaderAll &&
						<React.Fragment>
							<div className="personal-inventory__cell--condition-header">Condition</div>
							<div className="personal-inventory__cell--qty-header">Qty</div>
							<div className="personal-inventory__cell--notes-header l-flex">
								<div>Notes</div>
								<div className="l-full-width personal-inventory__text-light-gray l-margin-left--sm">({maxNoteLen} characters max)</div>
							</div>
						</React.Fragment>
					}
				</React.Fragment>
			)
		}
		if (itemType == "P") {
			return (
				<React.Fragment>
					<div className="personal-inventory__cell--find-header">Find a {itemTypeFullStr}</div>
					{isHeaderAll &&
						<React.Fragment>
							<div className="personal-inventory__cell--color-header">Part color</div>
							<div className="personal-inventory__cell--condition-header">Condition</div>
							<div className="personal-inventory__cell--qty-header">Qty</div>
							<div className="personal-inventory__cell--notes-header l-flex">
								<div>Notes</div>
								<div className="l-full-width personal-inventory__text-light-gray l-margin-left--sm">({maxNoteLen} characters max)</div>
							</div>
						</React.Fragment>
					}
				</React.Fragment>
			)
		}
		return (null);
	}

}

export class AddedItemControlBtn extends React.Component {
	render() {
		const { cntAddedItem, idx } = this.props.data;
		const isLast = this.isLast(cntAddedItem, idx);

		return (
			<div className={ "personal-inventory__cell--icon-add-remove " + ((!isLast) ? " l-margin-bottom" : "")}>
				<div className="l-flex l-column l-center-v l-full-height" >
					<div className="l-flex">
						<i id="MPI-addItem-btn" className="fa-solid fa-circle-plus l-cursor-pointer personal-inventory__icon-plus-circle" onClick={() => this.props.func.insItem(idx)} />
						{(cntAddedItem > 1) &&
							<i id="MPI-deleteItem-btn" className="fa-solid fa-circle-minus l-cursor-pointer personal-inventory__icon-minus-circle l-margin-left--sm" onClick={() => this.props.func.removeAddedItem(idx)}></i>
						}
					</div>
				</div>
			</div>
		)
	}

	isLast(cntAddedItem, idx) {
		if ((cntAddedItem - 1) > idx) {
			return false;

		}
		return true;
	}
}

export class ItemConditionDropDown extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { itemType, idx, conditionValue, strClass } = this.props.data;
		if (itemType != "S") {
			return (
				<select id="MPI-condition-dropdown" className={strClass} value={conditionValue} onChange={(e) => this.props.func.updateCondition(idx, e.target.value)}>
					<option value={6}>New</option>
					<option value={7}>Used</option>
				</select>
			)
		}
		else {
			return (
				<select id="MPI-condition-dropdown" className={strClass} value={conditionValue} onChange={(e) => this.props.func.updateCondition(idx, e.target.value)}>
					<option value={1}>New, Sealed</option>
					<option value={2}>New, Complete</option>
					<option value={3}>New, Incomplete</option>
					<option value={4}>Used, Complete</option>
					<option value={5}>Used, Incomplete</option>
				</select>

			)
		}
	}
}

export class PartOutButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { itemType, partoutOn, isCompact: isCompact } = this.props.data;

		if ("CMBG".includes(itemType)) {
			if (!isCompact) {
				return (
					<div className="l-flex l-center-v">
						{(partoutOn) && <div><i className="fa-solid fa-check text--bold l-margin-right--sm"></i></div>}
						{(!partoutOn) && this.getPartoutIcon(false)}
						<div className="l-flex l-center-v l-column l-margin-left--sm">Part out</div>
					</div>
				)
			}
			else {
				return (
					<div className="l-flex l-center-v">
						{this.getPartoutIcon(partoutOn)}
						<div className="l-flex l-center-v l-column l-margin-left--sm personal-inventory__hide-mobile"><span>Part out</span></div>
					</div>
				)
			}
		}

		if (itemType == "S") {
			if (!isCompact) {
				return (
					<div className="l-flex l-center-v">
						{this.getPartoutIcon(partoutOn)}
						<div className="l-flex l-center-v l-column l-margin-left--sm">Part out</div>
					</div>
				)
			}
			else {
				return (
					<div className="l-flex l-center-v">
						{this.getPartoutIcon(partoutOn)}
						<div className="l-flex l-center-v l-column l-margin-left--sm"><span className="personal-inventory__hide-mobile">Part out</span></div>
					</div>
				)
			}
		}


		return null;
	}

	getPartoutIcon(partoutOn) {
		if (partoutOn) {
			return (
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M2.361 14.667c0 .275.228.5.51.5h6.464c.245.546.55 1.053.926 1.5h-7.39c-1.126 0-2.038-.897-2.038-2V7.425c0-.281.06-.556.176-.813l1.324-2.924A2.039 2.039 0 0 1 4.195 2.5h7.444a2.04 2.04 0 0 1 1.862 1.188l1.324 2.924c.115.257.175.595.175.876v.097a5.646 5.646 0 0 0-2.845.478H2.36v6.604zM11.64 4H8.686v2.5h4.417l-1-2.203A.507.507 0 0 0 11.64 4zM2.732 6.5h4.426V4H4.195a.51.51 0 0 0-.466.297L2.732 6.5zM19.167 13c0 2.484-2.053 4.5-4.584 4.5C12.054 17.5 10 15.484 10 13s2.053-4.5 4.584-4.5c2.53 0 4.583 2.016 4.583 4.5zm-3.16-1.353-1.933 1.897-.913-.897a.512.512 0 0 0-.72 0 .49.49 0 0 0 0 .706l1.274 1.25a.512.512 0 0 0 .719 0l2.292-2.25a.49.49 0 0 0 0-.706.512.512 0 0 0-.72 0z" fill="#fff" />
				</svg>
			)
		}
		else {
			return (
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M13.964 2.5c.847 0 1.614.499 1.959 1.273l1.393 3.133c.12.275.184.57.184.87v7.581c0 1.182-.96 2.143-2.143 2.143H4.643A2.144 2.144 0 0 1 2.5 15.357v-7.58c0-.302.063-.596.185-.87l1.392-3.134A2.142 2.142 0 0 1 6.036 2.5h7.928zm0 1.607h-3.16v2.679h4.7l-1.05-2.36a.533.533 0 0 0-.49-.319zm1.929 4.286H4.107v6.964c0 .295.24.536.536.536h10.714a.537.537 0 0 0 .536-.536V8.393zM4.497 6.786h4.7V4.107H6.035a.536.536 0 0 0-.49.318l-1.05 2.36z" fill="#0A1E32" />
				</svg>
			)
		}
	}

}

